import s from "styled-components";
import { Button } from "_c/button";
import { Input } from "../index-styled";

export const Wrap = s.form`
  display: flex;
  width: 260px;
  margin: 0 auto;
  flex-direction: column;
  align-items: center;
  ${Input} {
    width: 260px;
  }
`;
export const InputSect = s.div`
  display: flex;
  margin-bottom: 7px;
  flex-direction: column;
`;
export const ForgotPassword = s.button`
  color: var(--font-color-accent);
  font-size: 12px;
  font-weight: 600;
  text-decoration: underline;
  margin: 15px 0;
`;
export const SubmitButton = s(Button)`
  margin-top: 10px;
`;
export const RestoreButton = s(Button)`
  margin-top: 0px;
`;
